// extracted by mini-css-extract-plugin
export default {"selectedPage":"Pagination_selectedPage__eBvuK"};